import React, { Component } from 'react'
import moment from "moment";
import { DatePicker } from 'antd';
import GenericSearchModalNew from './GenericSearchModalNew';
import dayjs from 'dayjs';
import IconsPath from '../../../assets/icons/index'
import '../../../styles/stylesheets/Assortment/TipsAssortment.scss'
import LanguageTranslator from '../../../locals/LanguageTranslator';
import GenericCustomButton from '../../GenericCustomButton';
import UseDatePickerLocale from '../../input/LocaleInputDatePicker';
const { RangePicker } = DatePicker;

export default class CustomSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columnDropdown: false,
            inputStr: "",
            itemCodes: this.props.data,
            headerType: this.props.headerType,
            columnBy: this.props.columnBy,
            checkboxSpace: false,
            activeTab: this.props.actionBarConfig && this.props.actionBarConfig.filters && this.props.actionBarConfig.filters.isItemRequire ? "itemFilters" : "customFilters",
            search: "",
            applyFilterEnabled: false,
            filterItems: { ...this.props.filterItems },
            checkedFilters: {},
            currentTab: "item",
            customHeaders: this.props.headersData.item && this.props.headersData.item.data && Object.keys(this.props.headersData.item.data).length === 0 ? [] : this.props.headersData.item && this.props.headersData.item.data && Object.keys(this.props.headersData.item.data["Custom Headers"]).length === 0 ? Object.keys(this.props.headersData.item.data["Default Headers"]) : this.props.headersData.item && this.props.headersData.item.data && Object.keys(this.props.headersData.item.data["Custom Headers"]),
            customHeadersType: this.props.headersData.item && this.props.headersData.item.data && this.props.headersData.item["Custom Headers"] === undefined || this.props.headersData.item && this.props.headersData.item.data && this.props.headersData.item["Custom Headers"].length === 0 ? "Default Headers" : "Custom Headers",
        };

        this.columnList = {
            pi: { indentNo: "Indent Number" },
            po: { orderNo: "Order Number", gensysOrderNo: "ERP Order Number" },
            openPo: { orderNumber: "PO Number" }
        };

        this.updatedLocale = UseDatePickerLocale();
    }

    getColumnType = (key, level) => {
        if (level === "main") {
            return this.state.filterItems?.columnType?.[key] ||
                this.props.headersData?.main?.data?.columnType?.[key];
        }
        return this.props.headersData?.item?.data?.columnType?.[key];
    }

    getPrefixedKey = (key, level) => `${level}__${key}`;

    splitPrefixedKey = (prefixedKey) => {
        const idx = prefixedKey.indexOf("__");
        return {
            level: prefixedKey.substring(0, idx),
            key: prefixedKey.substring(idx + 2)
        };
    }

    changeTab = (tab) => {
        this.setState({ activeTab: tab });
    }

    componentDidMount() {
        this.setState(() => {
            let checkedFilters = {};
            const appliedFilters = { ...this.props.appliedFilters };

            Object.keys(appliedFilters).forEach(key => {
                if (key === "item") {
                    // Item level filters
                    Object.keys(appliedFilters.item).forEach(itemKey => {
                        const columnType = this.props.headersData?.item?.data?.columnType?.[itemKey];
                        const prefixedKey = this.getPrefixedKey(itemKey, "item");

                        if (columnType === "DATE" && appliedFilters.item[itemKey]?.key) {
                            checkedFilters[prefixedKey] = {
                                ...this.getDateFromTo(appliedFilters.item[itemKey].key),
                                key: appliedFilters.item[itemKey].key
                            };
                        } else if (columnType === "LOV" || columnType === "SEARCH") {
                            const val = appliedFilters.item[itemKey];
                            checkedFilters[prefixedKey] = typeof val === "string" ? val.split(",") : val;
                        } else {
                            checkedFilters[prefixedKey] = appliedFilters.item[itemKey];
                        }
                    });
                } else {
                    // Main level filters
                    const columnType = this.props.filterItems?.columnType?.[key];
                    const prefixedKey = this.getPrefixedKey(key, "main");

                    if (columnType === "DATE" && appliedFilters[key]?.key) {
                        checkedFilters[prefixedKey] = {
                            ...this.getDateFromTo(appliedFilters[key].key),
                            key: appliedFilters[key].key
                        };
                    } else if (columnType === "LOV" || columnType === "SEARCH") {
                        const val = appliedFilters[key];
                        checkedFilters[prefixedKey] = typeof val === "string" ? val.split(",") : val;
                    } else {
                        checkedFilters[prefixedKey] = appliedFilters[key];
                    }
                }
            });

            return { checkedFilters };
        }, this.handleApplyFilterButton);
    }

    handleApplyFilterButton = () => {
        this.setState(prevState => {
            if (
                Object.keys(prevState.checkedFilters).length === 0 ||
                Object.values(prevState.checkedFilters).some(value =>
                    value === "" || value?.length === 0 || value?.from === "" || value?.to === ""
                )
            ) {
                return { applyFilterEnabled: false };
            }
            return { applyFilterEnabled: true };
        });
    }

    checkFilter = (key, level = "item") => {
        const prefixedKey = this.getPrefixedKey(key, level);

        if (this.state.checkedFilters[prefixedKey] === undefined) {
            const columnType = this.getColumnType(key, level);
            let defaultValue;

            switch (columnType) {
                case "NUMBER":  defaultValue = { from: "", to: "" }; break;
                case "LOV":
                case "SEARCH":  defaultValue = []; break;
                default:        defaultValue = "";
            }

            this.setState(prevState => ({
                checkedFilters: { ...prevState.checkedFilters, [prefixedKey]: defaultValue }
            }), this.handleApplyFilterButton);
        } else {
            this.setState(prevState => {
                let checkedFilters = { ...prevState.checkedFilters };
                delete checkedFilters[prefixedKey];
                return { checkedFilters };
            }, this.handleApplyFilterButton);
        }
    }

    handleInput = (e, key, level = "item") => {
        try { e.persist(); } catch (err) { }

        const prefixedKey = this.getPrefixedKey(key, level);
        const columnType = this.getColumnType(key, level);

        switch (columnType) {
            case "NUMBER": {
                this.setState(prevState => {
                    let checkedFilters = { ...prevState.checkedFilters };
                    if (e.target.dataset.type === "from") {
                        checkedFilters[prefixedKey] = { ...checkedFilters[prefixedKey], from: e.target.value };
                    } else {
                        checkedFilters[prefixedKey] = { ...checkedFilters[prefixedKey], to: e.target.value };
                    }
                    return { checkedFilters };
                }, this.handleApplyFilterButton);
                break;
            }
            case "DATE": {
                this.setState(prevState => {
                    let checkedFilters = { ...prevState.checkedFilters };
                    if (e === null) {
                        checkedFilters[prefixedKey] = "";
                    } else if (["SM_DATE_TODAY_VALUE", "SM_DATE_YESTERDAY_VALUE", "SM_DATE_LAST7DAYS_VALUE", "SM_DATE_LASTWEEK_VALUE", "SM_DATE_THISMONTH_VALUE", "SM_DATE_LASTMONTH_VALUE"].includes(e)) {
                        checkedFilters[prefixedKey] = { ...this.getDateFromTo(e), key: e };
                        return { checkedFilters, dateDropdown: "" };
                    } else {
                        checkedFilters[prefixedKey] = {
                            from: moment(e[0].$d).format('YYYY-MM-DD'),
                            to: moment(e[1].$d).format('YYYY-MM-DD')
                        };
                    }
                    return { checkedFilters };
                }, this.handleApplyFilterButton);
                break;
            }
            case "TIME": {
                this.setState(prevState => {
                    let checkedFilters = { ...prevState.checkedFilters };
                    if (e === null) {
                        checkedFilters[prefixedKey] = "";
                    } else {
                        checkedFilters[prefixedKey] = {
                            from: moment(e[0].$d).format('YYYY-MM-DD HH:mm'),
                            to: moment(e[1].$d).format('YYYY-MM-DD HH:mm')
                        };
                    }
                    return { checkedFilters };
                }, this.handleApplyFilterButton);
                break;
            }
            case "LOV": {
                this.setState(prevState => {
                    let checkedFilters = { ...prevState.checkedFilters };
                    const index = checkedFilters[prefixedKey].indexOf(e.target.dataset.value);
                    if (!~index) checkedFilters[prefixedKey].push(e.target.dataset.value);
                    else checkedFilters[prefixedKey].splice(index, 1);
                    return { checkedFilters };
                }, this.handleApplyFilterButton);
                break;
            }
            default: {
                this.setState(prevState => {
                    let checkedFilters = { ...prevState.checkedFilters };
                    checkedFilters[prefixedKey] = e.target.dataset.value || e.target.parentElement.dataset.value || e.target.value || "";
                    return { checkedFilters };
                }, this.handleApplyFilterButton);
            }
        }
    }

    selectItems = (field, items, level = "item") => {
        const prefixedKey = this.getPrefixedKey(field.filterKey, level);
        this.setState(prevState => ({
            checkedFilters: { ...prevState.checkedFilters, [prefixedKey]: items }
        }), this.handleApplyFilterButton);
    }

    getDateFromTo = key => {
        switch (key) {
            case "SM_DATE_TODAY_VALUE":
                return { from: moment().format('YYYY-MM-DD'), to: moment().format('YYYY-MM-DD') };
            case "SM_DATE_YESTERDAY_VALUE":
                return { from: moment().subtract(1, "day").format('YYYY-MM-DD'), to: moment().subtract(1, "day").format('YYYY-MM-DD') };
            case "SM_DATE_LAST7DAYS_VALUE":
                return { from: moment().subtract(7, "days").format('YYYY-MM-DD'), to: moment().subtract(1, "day").format('YYYY-MM-DD') };
            case "SM_DATE_LASTWEEK_VALUE":
                return { from: moment().subtract(1, 'week').startOf('isoWeek').format('YYYY-MM-DD'), to: moment().subtract(1, 'week').endOf('isoWeek').format('YYYY-MM-DD') };
            case "SM_DATE_THISMONTH_VALUE":
                return { from: moment().startOf('month').format('YYYY-MM-DD'), to: moment().format('YYYY-MM-DD') };
            case "SM_DATE_LASTMONTH_VALUE":
                return { from: moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'), to: moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD') };
            default:
                return { from: "", to: "" };
        }
    }

    showTextDropdown = (key, level) => () => {
        this.setState({ textDropdown: `${level}__${key}` },
            () => setTimeout(() => document.addEventListener("click", this.hideTextDropdown), 0));
    }

    hideTextDropdown = () => {
        this.setState({ textDropdown: "" },
            () => setTimeout(() => document.removeEventListener("click", this.hideTextDropdown), 0));
    }

    showSelectDropdown = (key, level) => () => {
        this.setState({ selectDropdown: `${level}__${key}` },
            () => setTimeout(() => document.addEventListener("click", this.hideSelectDropdown), 0));
    }

    hideSelectDropdown = e => {
        let path = e.path || (e.composedPath && e.composedPath());
        if (!path.some(elem => elem.id == "genericFilterSelectDropdown")) {
            this.setState({ selectDropdown: "" },
                () => document.removeEventListener("click", this.hideSelectDropdown));
        }
    }

    renderExtraFooter = (key, level) => () => {
        const prefixedKey = this.getPrefixedKey(key, level);
        const dateOptions = [
            { value: "SM_DATE_TODAY_VALUE", label: "Today" },
            { value: "SM_DATE_YESTERDAY_VALUE", label: "Yesterday" },
            { value: "SM_DATE_LAST7DAYS_VALUE", label: "Last 7 Days" },
            { value: "SM_DATE_LASTWEEK_VALUE", label: "Last Week" },
            { value: "SM_DATE_THISMONTH_VALUE", label: "This Month" },
            { value: "SM_DATE_LASTMONTH_VALUE", label: "Last Month" },
        ];
        return (
            <span className="date-picker-extra-footer">
                {dateOptions.map(opt => (
                    <label key={opt.value} className="radio-label">
                        <input
                            type="radio"
                            name="daterange"
                            checked={typeof this.state.checkedFilters[prefixedKey] === "object" && this.state.checkedFilters[prefixedKey]?.key === opt.value}
                            onChange={() => this.handleInput(opt.value, key, level)}
                        />
                        <span className="radio-check"></span>
                        <span className="radio-text"><LanguageTranslator>{opt.label}</LanguageTranslator></span>
                    </label>
                ))}
            </span>
        );
    }

    applyFilterOnItemLevel = () => {
        let filter = {};
        let item = {};

        Object.keys(this.state.checkedFilters).forEach(prefixedKey => {
            const { level, key } = this.splitPrefixedKey(prefixedKey);

            const isLOVorSEARCH =
                this.props.headersData?.main?.data?.columnType?.[key] === "LOV" ||
                this.props.headersData?.main?.data?.columnType?.[key] === "SEARCH" ||
                this.props.headersData?.item?.data?.columnType?.[key] === "LOV" ||
                this.props.headersData?.item?.data?.columnType?.[key] === "SEARCH";

            const value = isLOVorSEARCH
                ? this.state.checkedFilters[prefixedKey].join()
                : this.state.checkedFilters[prefixedKey];

            if (level === "main") {
                filter[key] = value;
            } else if (level === "item") {
                item[key] = value;
            }
        });

        this.props.close();
        this.props.applyFilter({ ...filter, item })();
    }

    handleCheckbox = () => {
        this.setState({ checkboxSpace: !this.state.checkboxSpace });
    }

    openColumnDropdown = () => {
        this.setState({ columnDropdown: !this.state.columnDropdown },
            () => setTimeout(() => document.addEventListener('click', this.closeColumnDropdown), 0));
    }

    closeColumnDropdown = () => {
        this.setState({ columnDropdown: false },
            () => setTimeout(() => document.removeEventListener('click', this.closeColumnDropdown), 0));
    }

    setColumnBy = columnBy => () => {
        this.setState({ columnBy });
    }

    handleCustomSearchInput = e => {
        if (this.state.checkboxSpace) {
            let addItem = (e.type === "keydown" && (e.key === "Enter" || e.key === " ")) || e.target.value.includes(" ") || e.target.value.includes("\t") || e.target.value.includes(",");
            if (addItem) this.addItemCode(e.target.value);
            else this.setState({ inputStr: e.target.value });
        } else {
            let addItem = (e.type === "keydown" && e.key === "Enter") || e.target.value.includes("\t") || e.target.value.includes(",");
            if (addItem) this.addItemCode(e.target.value);
            else this.setState({ inputStr: e.target.value });
        }
    }

    addItemCode = inputStr => {
        let newItemCodes;
        if (inputStr.includes(",")) {
            newItemCodes = inputStr.split(",");
        } else {
            newItemCodes = this.state.checkboxSpace ? inputStr.split(" ") : inputStr.split(",");
        }
        const newItemCodesFormatted = [];
        newItemCodes.forEach(item => {
            let itemFormatted = item.trim()?.replace("\t", "");
            if (itemFormatted.length && this.state.itemCodes.indexOf(itemFormatted) === -1) {
                newItemCodesFormatted.push(itemFormatted);
            }
        });
        this.setState(prevState => ({
            itemCodes: [...prevState.itemCodes, ...newItemCodesFormatted],
            inputStr: ""
        }));
    }

    removeItemCode = item => () => {
        this.setState(prevState => {
            let itemCodes = [...prevState.itemCodes];
            itemCodes.splice(itemCodes.indexOf(item), 1);
            return { itemCodes };
        });
    }

    clearAll = () => {
        this.setState({ itemCodes: [] });
    }

    onSubmit = () => {
        this.props.submit(this.state.columnBy, this.state.itemCodes);
    }

    closeModal = () => {
        document.getElementById("reportModal")?.classList?.remove("from-bot-in");
        document.getElementById("reportModal")?.classList?.add("from-bot-out");
        setTimeout(() => { this.props.close(); }, 100);
    }

    renderFilterValue = (key, level) => {
        const prefixedKey = this.getPrefixedKey(key, level);
        const columnType = this.getColumnType(key, level);
        const value = this.state.checkedFilters[prefixedKey];

        if (value === undefined) {
            return <span className="asnfbb-right not-checked" onClick={() => this.checkFilter(key, level)} />;
        }

        switch (columnType) {
            case "NUMBER":
                return (
                    <span className="asnfbb-right">
                        <input
                            type="number"
                            data-type="from"
                            id={`${prefixedKey}From`}
                            value={value === "" ? "" : value.from}
                            placeholder="Enter From Value"
                            onChange={(e) => this.handleInput(e, key, level)}
                        />
                        <input
                            type="number"
                            data-type="to"
                            className="asnfbbr-poquantity"
                            id={`${prefixedKey}To`}
                            value={value === "" ? "" : value.to}
                            placeholder="Enter To Value"
                            onChange={(e) => this.handleInput(e, key, level)}
                        />
                    </span>
                );

            case "DATE":
                return (
                    <span className="asnfbb-right">
                        <RangePicker
                            locale={this.updatedLocale}
                            format="YYYY-MM-DD"
                            id={prefixedKey}
                            value={!value || value === "" ? null : [dayjs(value.from), dayjs(value.to)]}
                            onChange={(e) => this.handleInput(e, key, level)}
                            renderExtraFooter={this.renderExtraFooter(key, level)}
                            onOpenChange={open => this.setState({ dateDropdown: open ? prefixedKey : "" })}
                            open={this.state.dateDropdown === prefixedKey}
                        />
                    </span>
                );

            case "TIME":
                return (
                    <span className="asnfbb-right">
                        <RangePicker
                            locale={this.updatedLocale}
                            format="YYYY-MM-DD HH:mm"
                            showTime={{ format: "HH:mm", defaultValue: [moment('00:00', 'HH:mm'), moment('00:00', 'HH:mm')] }}
                            id={prefixedKey}
                            value={!value || value === "" ? null : [dayjs(value.from), dayjs(value.to)]}
                            onChange={(e) => this.handleInput(e, key, level)}
                        />
                    </span>
                );

            case "LOV":
                return (
                    <span className="asnfbb-right select" onClick={this.showSelectDropdown(key, level)}>
                        <input
                            type="text"
                            id={prefixedKey}
                            placeholder="Select Options"
                            value={value.length > 1 ? `${value[0]} + ${value.length - 1}` : value.length === 1 ? value[0] : ""}
                            readOnly
                        />
                        <button className='asnfbbr-input-arrow' onClick={this.showSelectDropdown(key, level)}>
                            <IconsPath.DownArrowNew />
                        </button>
                        {value.length > 1 && <span className="asnfbbr-select-count"> + {value.length - 1}</span>}
                        {this.state.selectDropdown === prefixedKey &&
                            <div id="genericFilterSelectDropdown" className="dropdown-menu-city1 gen-width-auto zi999">
                                <ul className="dropdown-menu-city-item">
                                    {this.state.filterItems["Lov Headers"]?.[key]?.map(item => (
                                        <li key={item}>
                                            <label className="checkBoxLabel0">
                                                <input
                                                    type="checkBox"
                                                    checked={value.indexOf(item) !== -1}
                                                    onChange={(e) => this.handleInput(e, key, level)}
                                                    data-value={item}
                                                />
                                                <span className="checkmark1"></span>
                                                {item}
                                            </label>
                                        </li>
                                    ))}
                                </ul>
                            </div>}
                    </span>
                );

            case "SEARCH":
                return (
                    <span className="asnfbb-right search">
                        <GenericSearchModalNew
                            field={{
                                filterKey: key,
                                entity: this.props.headersData[this.state.currentTab].data.tableName[key],
                                key: this.props.headersData[this.state.currentTab].data.tableColumnMap[key],
                                value: this.props.headersData[this.state.currentTab].data[this.state.customHeadersType][key]
                            }}
                            emptyAttributes={true}
                            showLabel={false}
                            selectedItems={{ [this.props.headersData[this.state.currentTab].data.tableColumnMap[key]]: value }}
                            selectItems={(field, items) => this.selectItems(field, items, level)}
                            pasteConfiguration={{
                                "enabled": true,
                            }}
                            {...this.props}
                        />
                    </span>
                );

            default:
                return (
                    <span className="asnfbb-right">
                        <input
                            type="text"
                            id={prefixedKey}
                            value={value === undefined ? "" : value === "SM_TEXT_EMPTY_VALUE" ? "is Empty" : value === "SM_TEXT_NOT_EMPTY_VALUE" ? "is Not Empty" : value}
                            placeholder="Enter Value"
                            onChange={(e) => this.handleInput(e, key, level)}
                            disabled={["SM_TEXT_EMPTY_VALUE", "SM_TEXT_NOT_EMPTY_VALUE"].includes(value)}
                        />
                        <button className='asnfbbr-input-arrow' onClick={this.showTextDropdown(key, level)}>
                            <IconsPath.DownArrowNew />
                        </button>
                        {this.state.textDropdown === prefixedKey &&
                            <span className="asnfbbr-inner">
                                <span className="asnfbbr-all-vendor">
                                    <li data-value="" onClick={(e) => this.handleInput(e, key, level)}>
                                        <LanguageTranslator tag='button'>Custom</LanguageTranslator>
                                        <LanguageTranslator tag='span' className="asnfbbrav-code">Type Custom Value</LanguageTranslator>
                                    </li>
                                    <li data-value="SM_TEXT_EMPTY_VALUE" onClick={(e) => this.handleInput(e, key, level)}>
                                        <button>is Empty</button>
                                    </li>
                                    <li data-value="SM_TEXT_NOT_EMPTY_VALUE" onClick={(e) => this.handleInput(e, key, level)}>
                                        <button>is Not Empty</button>
                                    </li>
                                </span>
                            </span>}
                    </span>
                );
        }
    }

    render() {
        return (
            <div className="modal">
                <div className="backdrop" onClick={this.closeModal}></div>
                <div id='reportModal' className="custom-search-modal from-bot-in relative flex flex-col pointer-events-auto outline-none w-[80vw] h-[80vh] max-w-[1300px] max-h-[800px] bg-white overflow-hidden border-none shadow-none rounded-none pb-[20px]">
                    
                    {/* Header */}
                    <div className="csm-head flex items-center justify-between py-[15px] px-[25px] h-[65px] border-b border-borderSlateGrey">
                        <div className="csmh-left">
                            {this.props.actionBarConfig.filters.isItemRequire &&
                                <LanguageTranslator tag="h3" className='m-[0] text-sm font-bold text-fontBlack'>Item Filters</LanguageTranslator>}
                        </div>
                        <div className="csmh-right flex items-center justify-end gap-3">
                            <GenericCustomButton type='default' onClick={this.closeModal} label="Close" />
                            {this.state.activeTab === "customFilters" &&
                                <GenericCustomButton
                                    type='primary'
                                    sendEventAnalyticsToGoogle={true}
                                    eventAnlyticsLabel={"Custom Search Submit Click"}
                                    disabled={this.state.itemCodes.length === 0 || this.state.columnBy === ''}
                                    onClick={this.onSubmit}
                                    label="Apply Search"
                                />}
                            {this.state.activeTab === "itemFilters" &&
                                <GenericCustomButton
                                    type='primary'
                                    sendEventAnalyticsToGoogle={true}
                                    disabled={!this.state.applyFilterEnabled}
                                    onClick={this.applyFilterOnItemLevel}
                                    label="Apply Item Filter"
                                />}
                        </div>
                    </div>

                    {/* Tabs */}
                    {this.props.actionBarConfig.filters.isItemRequire &&
                        <div className="subscription-tab st-new-tab bg-white p-[10px] pr-[25px] border-b border-[#dee2e6]">
                            <ul className="nav nav-tabs subscription-tab-list">
                                <li className={this.state.activeTab === "itemFilters" ? "nav-item active" : "nav-item"}>
                                    <LanguageTranslator tag='a' className="nav-link st-btn" onClick={() => this.changeTab("itemFilters")}>Item Filters</LanguageTranslator>
                                </li>
                                <li className='stl-clear-all'>
                                    {this.state.activeTab === "itemFilters"
                                        ? <GenericCustomButton label="Clear all Filters" onClick={() => this.setState({ checkedFilters: {} }, this.handleApplyFilterButton)} type="underline" />
                                        : <GenericCustomButton label="Clear All" onClick={this.clearAll} type="underline" />}
                                </li>
                            </ul>
                        </div>}

                    {/* Item Filters Tab */}
                    {this.state.activeTab === "itemFilters" &&
                        <div className='item-filters h-full w-full flex flex-col py-2.5 px-[25px] overflow-auto'>
                            <div className="asnfb-head table w-full">
                                <LanguageTranslator tag="span" className="asnfb-left text-sm font-semibold text-[#12203c] block w-[40%] float-left">Header</LanguageTranslator>
                                <LanguageTranslator tag="span" className="asnfb-right text-sm font-semibold text-[#12203c] block w-[60%] float-left">Value</LanguageTranslator>
                            </div>
                            {this.props.actionBarConfig.filters.isItemRequire &&
                                <div className="asnfb-body block w-full py-2.5 px-0">
                                    {this.state.customHeaders?.length === 0
                                        ? <LanguageTranslator tag="span">No filters available!</LanguageTranslator>
                                        : this.state.customHeaders?.map(key => {
                                            const level = "item";
                                            const prefixedKey = this.getPrefixedKey(key, level);

                                            if (
                                                this.props.headersData?.[this.state.currentTab]?.data?.[this.state.customHeadersType]?.[key]?.toLowerCase()?.includes(this.state.search.toLowerCase()) &&
                                                this.props.headersData?.[this.state.currentTab]?.data?.columnType?.[key] !== "NOSORT"
                                            ) {
                                                return (
                                                    <div key={prefixedKey} className="asnfb-item table w-full mb-2.5">
                                                        <span className="asnfbb-left relative block w-[40%] float-left">
                                                            <span className="asn-check">
                                                                <div className="checkSeperate checkBoxBorder">
                                                                    <LanguageTranslator tag="label" className="checkBoxLabel0">
                                                                        <input
                                                                            type="checkBox"
                                                                            onChange={() => this.checkFilter(key, level)}
                                                                            checked={this.state.checkedFilters[prefixedKey] !== undefined}
                                                                        />
                                                                        <LanguageTranslator>
                                                                            {this.props.headersData[this.state.currentTab].data[this.state.customHeadersType][key]}
                                                                        </LanguageTranslator>
                                                                        <span className="checkmark1"></span>
                                                                    </LanguageTranslator>
                                                                </div>
                                                            </span>
                                                        </span>
                                                        {this.renderFilterValue(key, level)}
                                                    </div>
                                                );
                                            }
                                            return null;
                                        })}
                                </div>}
                        </div>}

                    {/* Custom Search Tab */}
                    {this.state.activeTab === "customFilters" &&
                        <div className="csm-body w-full block py-2.5 px-[25px] h-[calc(100%-65px)] overflow-auto pt-[0]">
                            <div className="csmb-top flex items-center justify-between py-[15px] px-0">
                                <div className="csmbt-left relative flex">
                                    <div className="gen-custom-select">
                                        <button type="button" onClick={this.openColumnDropdown}>
                                            {this.props.columnList
                                                ? this.state.columnBy
                                                    ? <LanguageTranslator>{this.props.columnList[this.state.headerType][this.state.columnBy]}</LanguageTranslator>
                                                    : <LanguageTranslator>Select Custom Search</LanguageTranslator>
                                                : <LanguageTranslator>{this.columnList[this.props.page][this.state.columnBy]}</LanguageTranslator>}
                                            <svg width="8" height="4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M4 4 0 0h8L4 4z" fill="#21314B" />
                                            </svg>
                                        </button>
                                        {this.state.columnDropdown &&
                                            <div className="gcs-dropdown">
                                                <ul>
                                                    {this.props.columnList
                                                        ? !this.props.columnList[this.state.headerType] || Object.keys(this.props.columnList[this.state.headerType]).length === 0
                                                            ? <LanguageTranslator tag="li">No Filters Available!</LanguageTranslator>
                                                            : Object.keys(this.props.columnList[this.state.headerType]).map(key => (
                                                                <React.Fragment key={key}>
                                                                    {(this.props.columnList.columnType[key] === "LOV" || this.props.columnList.columnType[key] === "SEARCH") &&
                                                                        <LanguageTranslator tag='li' onClick={this.setColumnBy(key)}>
                                                                            {this.props.columnList[this.state.headerType][key]}
                                                                        </LanguageTranslator>}
                                                                </React.Fragment>
                                                            ))
                                                        : Object.keys(this.columnList[this.props.page]).map(key => (
                                                            <li key={key} onClick={this.setColumnBy(key)}>
                                                                {this.columnList[this.props.page][key]}
                                                            </li>
                                                        ))}
                                                </ul>
                                            </div>}
                                    </div>
                                    <div className="csmbtl-col relative ml-[15px] flex flex-row-reverse items-center">
                                        <LanguageTranslator tag="p" className='text-xs font-medium m-[0] pl-[5px] text-[#12203c]'>Use Spacebar for Enter/Return</LanguageTranslator>
                                        <label className="checkBoxLabel0">
                                            <input type="checkBox" checked={this.state.checkboxSpace} onChange={this.handleCheckbox} />
                                            <span className="checkmark1"></span>
                                        </label>
                                    </div>
                                </div>
                                <div className="csmbt-right flex items-center justify-end">
                                    {!this.props.actionBarConfig.filters.isItemRequire &&
                                        <GenericCustomButton
                                            onClick={this.clearAll}
                                            label="Clear All"
                                            className='bg-white border-none rounded-[0] p-[3px] text-[#21314b] text-xs font-semibold'
                                        />}
                                </div>
                            </div>
                            <div className="csmb-bottom border border-borderSlateGrey rounded min-h-[220px] w-full">
                                <div className="csmbb-type-area">
                                    <div className="csmbbta-left">
                                        <input
                                            id="inputStr"
                                            value={this.state.inputStr}
                                            onChange={this.handleCustomSearchInput}
                                            onKeyDown={this.handleCustomSearchInput}
                                            autoComplete="off"
                                            type="text"
                                            disabled={this.state.columnBy === ""}
                                            placeholder={`Type ${this.state.columnBy === '' ? '' : this.props.columnList ? this.props.columnList[this.state.headerType][this.state.columnBy] : ""} or paste comma separated values...`}
                                        />
                                    </div>
                                    <div className="csmbbta-right">
                                        <p>
                                            <LanguageTranslator>Add multiple values by pressing</LanguageTranslator>
                                            {this.state.checkboxSpace && <React.Fragment><LanguageTranslator tag="i"> Space Bar</LanguageTranslator> <LanguageTranslator>or</LanguageTranslator> </React.Fragment>}
                                            <LanguageTranslator tag="i">Return/Enter</LanguageTranslator> (&#9166;)
                                        </p>
                                    </div>
                                </div>
                                <div className="csmbb-tags">
                                    <h3>
                                        <LanguageTranslator>Total</LanguageTranslator>{" "}
                                        {this.props.columnList ? this.props.columnList[this.state.headerType][this.state.columnBy] : this.columnList[this.props.page][this.state.columnBy]}
                                        {this.state.columnBy ? 's' : null}: {this.state.itemCodes.length}
                                    </h3>
                                    <div className="csmbbt-inner">
                                        {this.state.itemCodes.map(item => (
                                            <span key={item} className="csmbbti-tag">
                                                <span className="csmbbtit-text">{item}</span>
                                                <span className="csmbbtit-close" onClick={this.removeItemCode(item)}>&#x2715;</span>
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>}
                </div>
            </div>
        );
    }
}